import { ProjectFile } from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {TaskCheckItem} from './task-checkitem';

@JsonObject('model.ShortTask')
export class ShortTask extends AbstractModel {

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(Number, 'number')
  number?: number;

  @JsonProperty(String, 'assignedUserName')
  assignedUserName?: string;

  shortAssigned?: string;

  @JsonProperty(String, 'authorName')
  authorName?: string;

  shortAuthor?: string;

  @JsonProperty(DateConverter, 'completed')
  completed?: Date;

  @JsonProperty(DateConverter, 'deadline')
  deadline?: Date;

  @JsonProperty(DateConverter, 'created')
  created?: Date;

  @JsonProperty(DateConverter, 'lastUpdatedDate')
  lastUpdatedDate?: Date;

  @JsonProperty(String, 'text')
  text?: string;

  @JsonProperty(Number, 'projectId')
  projectId?: number;

  @JsonProperty(String, 'projectName')
  projectName?: string;

  @JsonProperty(Number, 'totalComments')
  totalComments?: number;

  @JsonProperty(Number, 'unreadComments')
  unreadComments?: number;

  @JsonProperty(Number, 'checkitemsTotal')
  checkitemsTotal?: number;

  @JsonProperty([TaskCheckItem], 'checkItems')
  checkItems?: TaskCheckItem[];

  @JsonProperty(Number, 'checkitemsCompleted')
  checkitemsCompleted?: number;

  @JsonProperty(Boolean, 'creationNotified')
  creationNotified?: boolean;

  @JsonProperty(Boolean, 'dateMoveNotified')
  dateMoveNotified?: boolean;

  @JsonProperty(Boolean, 'hasFiles')
  hasFiles?: boolean;

  @JsonProperty(Boolean, 'isSample')
  isSample?: boolean;

  @JsonProperty([Number], 'photoIds')
  photoIds?: number[];

  @JsonProperty(String, 'creationNfsStatus')
  creationNfsStatus?: string;

  @JsonProperty(String, 'dateMoveNfsStatus')
  dateMoveNfsStatus?: string;

  @JsonProperty(String, 'deliveryInstructions')
  deliveryInstructions?: string;

  progressBarNum?: number;
  colorNum?: string;

  @JsonProperty(String, 'clazz')
  clazz?: string;

  @JsonProperty(Boolean, 'isWorkOnSite')
  isWorkOnSite?: boolean;

  @JsonProperty(Boolean, 'isLock')
  isLock?: boolean;

  @JsonProperty([ProjectFile], 'files')
  files?: ProjectFile[] = [];

  collapsed?: boolean;

}
